import { Row, Col, Container, InputGroup } from 'react-bootstrap';
import AddButton from '../../User/UserFormNew/components/AddButton';
import useDocumentType from '../hooks/useDocumentType';
import FilterModal from '../../common/filter-modal/FilterModal';
import TextInput from '../../../../Components/GenericInputText/TextInput';
import { SearchSVG } from '../../../img/GlobalSVG';
import DataList from './DataList';
import SearchIndicationPage from '../../User/Personas/Providers/Doctors/SearchIndicationPage';
import {
  BlobCard,
  DoctorCard,
  BrokerCard,
  MemberDependentCard,
} from './DataCard';
import Skeleton from '../skeleton/ButtonSkeleton';

const DocumentType = ({
  docType,
  docTypeMeta,
  resetDocType,
  setResetDocType,
  setPhysicianType,
  physicianType,
  selectedDocTypeData,
  setSelectedDocTypeData,
  loadLocation,
  setLoadLocation,
  locationTypeMeta,
  selectedLocationData,
  setSelectedLocationData,
  defaultLocationloader,
  setDefaultLocationloader,
  defaultValueskeletonLoader,
  setDefaultValueSkeletonLoader,
  displayFirstRecord,
  providerFieldAlignment = 'verticle',
}) => {
  const {
    openBlobModal,
    docTypeData,
    searchString,
    skeletonLoader,
    showMoreData,
    isServerError,
    setOpenBlobModal,
    setSearchString,
    selectChangeHandler,
    setDocTypeData,
    deleteSelectedDocype,
    searchStringHandler,
    setCurrentPage,
    setShowMoreData,
    deleteLocationHandler,
    getMaskedSsn,
  } = useDocumentType({
    docType,
    resetDocType,
    setResetDocType,
    physicianType,
    selectedDocTypeData,
    setSelectedDocTypeData,
    setSelectedLocationData,
    loadLocation,
    setLoadLocation,
    defaultLocationloader,
    setDefaultLocationloader,
    defaultValueskeletonLoader,
    setDefaultValueSkeletonLoader,
    displayFirstRecord,
  });

  //console.log('selectedDocTypeData--@', selectedDocTypeData);
  //console.log('resetDocType--@', resetDocType);
  //console.log('docTypeData--@', docTypeData);
  //console.log('physicianType--@', physicianType);
  //console.log('showMoreData--@', showMoreData);

  return (
    <Row className="block-of-business-container">
      {!selectedDocTypeData && (
        <>
          {providerFieldAlignment === 'verticle' && (
            <>
              {defaultValueskeletonLoader ? (
                <Skeleton />
              ) : (
                <Col sm={12}>
                  <AddButton
                    onClick={() => {
                      setOpenBlobModal(true);
                      setShowMoreData(false);
                      (docType.value === 'PHYSICIAN' ||
                        docType.value === 'CONNECTOR' ||
                        docType.value === 'FACILITY') &&
                        setPhysicianType('F');
                    }}
                    className={'add-button-active reports-blob-button'}
                    label={docTypeMeta.Buttonlabel}
                  />
                </Col>
              )}
              {(docType.value === 'PHYSICIAN' ||
                docType.value === 'CONNECTOR' ||
                docType.value === 'FACILITY') && (
                <Col sm={12} className="mt-3">
                  <AddButton
                    onClick={() => {
                      setOpenBlobModal(true);
                      setPhysicianType('D');
                      setShowMoreData(false);
                    }}
                    className={'add-button-active reports-blob-button'}
                    label={docTypeMeta.ExtraButtonLabel}
                  />
                </Col>
              )}
            </>
          )}

          {providerFieldAlignment === 'horizontal' && (
            <div className="d-flex w-100 justify-content-around align-items-center">
              {defaultValueskeletonLoader ? (
                <Skeleton />
              ) : (
                <div className="selector-feild">
                  <AddButton
                    onClick={() => {
                      setOpenBlobModal(true);
                      setShowMoreData(false);
                      (docType.value === 'PHYSICIAN' ||
                        docType.value === 'CONNECTOR' ||
                        docType.value === 'FACILITY') &&
                        setPhysicianType('F');
                    }}
                    className={'add-button-active reports-blob-button'}
                    label={docTypeMeta.Buttonlabel}
                  />
                </div>
              )}
              <div className="text-field">
                <span>Or</span>
              </div>
              {(docType.value === 'PHYSICIAN' ||
                docType.value === 'CONNECTOR' ||
                docType.value === 'FACILITY') && (
                <div className="selector-feild">
                  <AddButton
                    onClick={() => {
                      setOpenBlobModal(true);
                      setPhysicianType('D');
                      setShowMoreData(false);
                    }}
                    className={'add-button-active reports-blob-button'}
                    label={docTypeMeta.ExtraButtonLabel}
                  />
                </div>
              )}
            </div>
          )}
        </>
      )}
      <FilterModal
        showBackButton={false}
        isVisible={openBlobModal}
        onHide={() => {
          setSearchString('');
          setOpenBlobModal(false);
        }}
        applyFilterHandler={selectChangeHandler}
        showCancel={true}
        titleLabel={
          !loadLocation ? docTypeMeta.titleLabel : locationTypeMeta.titleLabel
        }
        showApply={true}
        showApplyLabel="Add Selected"
      >
        <Container className="mt-3 mb-3">
          {openBlobModal ? (
            <>
              <Row>
                <Col sm={12}>
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label={
                        !loadLocation
                          ? docTypeMeta.subtitleLabel
                          : locationTypeMeta.subtitleLabel
                      }
                      append={
                        <InputGroup.Text>
                          <SearchSVG.SearchSVG className="primary-text-color" />
                        </InputGroup.Text>
                      }
                      inputProps={{
                        type: 'text',
                        placeholder: `Search by name or ${
                          !loadLocation
                            ? docTypeMeta.labelIdText
                            : locationTypeMeta.labelIdText
                        }`,
                        value: searchString,
                        onChange: (e) => {
                          searchStringHandler(e.target.value);
                        },
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
              </Row>
              {(docType.value === 'PHYSICIAN' ||
                docType.value === 'CONNECTOR' ||
                docType.value === 'FACILITY' ||
                docType.value === 'EMPLOYEE' ||
                docType.value === 'DEPENDENT') &&
                searchString?.length < 3 &&
                !skeletonLoader && (
                  <Container className="mt-3 mb-3">
                    <SearchIndicationPage
                      mainLabel={
                        docType.value === 'EMPLOYEE' ||
                        docType.value === 'DEPENDENT'
                          ? 'Start typing <Name or Member ID> to search'
                          : ''
                      }
                      subLabel={
                        docType.value === 'EMPLOYEE' ||
                        docType.value === 'DEPENDENT'
                          ? 'Enter a search criteria for better search results.'
                          : ''
                      }
                    />
                  </Container>
                )}
              <Row>
                <Col sm={12} className="mb-1 docType-data-list">
                  <DataList
                    data={docTypeData}
                    selectChangeHandler={selectChangeHandler}
                    displayId={
                      !loadLocation
                        ? docTypeMeta.displayId
                        : locationTypeMeta.displayId
                    }
                    displayLabel={
                      !loadLocation
                        ? docTypeMeta.displayLabel
                        : locationTypeMeta.displayLabel
                    }
                    labelIdText={
                      !loadLocation
                        ? docTypeMeta.labelIdText
                        : locationTypeMeta.labelIdText
                    }
                    rightValueForLocationDisplayID={
                      !loadLocation
                        ? docTypeMeta.rightValueForLocationDisplayID
                        : locationTypeMeta.rightValueForLocationDisplayID
                    }
                    searchString={searchString}
                    modalFor="blob"
                    setDocTypeData={setDocTypeData}
                    skeletonLoader={skeletonLoader}
                    docType={docType}
                    isServerError={isServerError}
                    physicianType={physicianType}
                    getMaskedSsn={getMaskedSsn}
                  />
                </Col>
              </Row>
              <Row className="mt-3 ml-1">
                {showMoreData && (
                  <div
                    className="panel-card-link"
                    onClick={() => {
                      setCurrentPage((val) => val + 1);
                    }}
                    role="button"
                  >
                    Show More
                  </div>
                )}
              </Row>
            </>
          ) : (
            <></>
          )}
        </Container>
      </FilterModal>
      {selectedDocTypeData && (
        <Col sm={12} className="mt-3">
          {(docType.value === 'Block of Business' ||
            docType.value === 'CLIENT' ||
            docType.value === 'Location') && (
            <BlobCard
              selectedDocTypeData={selectedDocTypeData}
              docTypeMeta={docTypeMeta}
              deleteSelectedDocype={deleteSelectedDocype}
              setLoadLocation={setLoadLocation}
              docType={docType}
              setOpenBlobModal={setOpenBlobModal}
              selectedLocationData={selectedLocationData}
              deleteLocationHandler={deleteLocationHandler}
            />
          )}
          {(docType.value === 'PHYSICIAN' ||
            docType.value === 'CONNECTOR' ||
            docType.value === 'FACILITY') && (
            <DoctorCard
              selectedDocTypeData={selectedDocTypeData}
              docTypeMeta={docTypeMeta}
              deleteSelectedDocype={deleteSelectedDocype}
              physicianType={physicianType}
            />
          )}
          {docType.value === 'BROKER' && (
            <BrokerCard
              selectedDocTypeData={selectedDocTypeData}
              docTypeMeta={docTypeMeta}
              deleteSelectedDocype={deleteSelectedDocype}
              physicianType={physicianType}
            />
          )}
          {(docType.value === 'EMPLOYEE' || docType.value === 'DEPENDENT') && (
            <MemberDependentCard
              selectedDocTypeData={selectedDocTypeData}
              deleteSelectedDocype={deleteSelectedDocype}
              getMaskedSsn={getMaskedSsn}
            />
          )}
        </Col>
      )}
    </Row>
  );
};

export default DocumentType;
